import { render, staticRenderFns } from "./notify_letter.vue?vue&type=template&id=4fb2bbfc&scoped=true&"
import script from "./notify_letter.vue?vue&type=script&lang=js&"
export * from "./notify_letter.vue?vue&type=script&lang=js&"
import style0 from "./notify_letter.vue?vue&type=style&index=0&id=4fb2bbfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb2bbfc",
  null
  
)

export default component.exports